var l={xxl:64,xl:34,large:24,normal:18,medium:18,small:16,xsmall:10};export{l as a};
